import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { industries } from '../../mockData';
import { ArrowRight } from 'lucide-react';

const IndustriesOverview = () => {
  return (
    <section
  className="relative py-24 bg-cover bg-center"
  style={{
    backgroundImage:
      "url('https://media.istockphoto.com/id/2217364770/vector/vector-of-futuristic-cityscape-with-smart-buildings-and-neon-lights-in-red-and-orange-colors.jpg?s=612x612&w=0&k=20&c=EzogDFB7kuDHDaLyosf4FAID6X8CNjezmmlean-qS-s=')",
  }}
>

  {/* Overlay */}
  <div className="absolute inset-0 bg-black/70"></div>

  {/* Content */}
  <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
        Industry Expertise
      </h2>

      <p className="text-xl text-gray-200 max-w-3xl mx-auto">
        Creating business value at the intersection of your industry transformation and today's latest technology innovation
      </p>
    </div>

    {/* Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {industries.map((industry) => {
        const IconComponent = Icons[industry.icon] || Icons.Building;
        return (
          <Link
            key={industry.id}
            to={`/industries/${industry.slug}`}
            className="group bg-white/90 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:border-indigo-500 hover:shadow-2xl transition-all duration-300"
          >
            <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-indigo-600 transition-colors duration-300">
              <IconComponent className="w-6 h-6 text-indigo-600 group-hover:text-white transition-colors duration-300" />
            </div>

            <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors duration-200">
              {industry.name}
            </h3>

            <p className="text-sm text-gray-600 line-clamp-2 mb-3">
              {industry.description}
            </p>

            <div className="flex items-center text-indigo-600 font-medium text-sm group-hover:translate-x-1 transition-transform duration-200">
              <span>Explore</span>
              <ArrowRight className="w-4 h-4 ml-1" />
            </div>
          </Link>
        );
      })}
    </div>

  </div>
</section>
  );
};

export default IndustriesOverview;